import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PG_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#PG_svg__a)" }, /* @__PURE__ */ e.createElement("rect", { width: 32, height: 24, rx: 2, fill: "#E11C1B" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0l32 24H0V0z",
      fill: "#1D1D1D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.084 18.269h1.332l.633-1.494.745 1.484 1.364.074-1.166 1.27.599 1.529-1.482-.852-1.37.86.517-1.486-1.172-1.385zM3.084 14.269h1.332l.633-1.494.745 1.484 1.364.074-1.166 1.27.599 1.529-1.482-.852-1.37.86.517-1.486-1.172-1.385zM7.084 12.269h1.332l.633-1.494.745 1.484 1.364.074-1.166 1.27.599 1.529-1.482-.852-1.37.86.517-1.486-1.172-1.385z",
      fill: "#EEEEF6"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.71 16.564l.916-.03.33-.944.372.939.842.081-.758.536.611.95-1.06-.397-.92.41.485-.937-.817-.608zM11.71 14.565l.916-.03.33-.945.372.939.842.081-.758.536.611.95-1.06-.397-.92.41.485-.937-.817-.607z",
      fill: "#EEEEF6"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.084 2s-3.089.616-2.222 4.91h-.44s.035-.224-.388-.356c-.424-.13-.34-.082-.558 0-.218.082-1.548 0-1.548 0v.165l.94.406s-.022.339.371.526c.394.188.68.278.68.278s.058.374-.311.374-1.852-.48-2.38.7C14.702 10.184 14 11.051 14 11.051h.79l-.211.264h.89l-.24.136s1.101-.012 1.187-.136c.086-.125 0 .337 0 .337s1.067-.487 1.126-.601l.498.342.142-.579.535.237.145-.551s1.512 2.529 2.659 2.384v-.42l1.046.42.133-.187s1.265.516 1.654.563l-.278-.563h.278l-.278-1.045h.278l-.555-.838.155-.226-.103-.298s2.036.648 1.944 1.68c-.092 1.031-.998 1.448-.998 1.448s-.87.266-1.655.209c0 0 .623.736 1.942.486s1.756-1.528 1.756-1.528.605 1.256.107 1.917c-.498.66-2.714 1.124-2.714 1.124s.802.47 1.562.35c.76-.121 1.943-.783 2.172-1.863.23-1.08-.79-3.072-1.253-3.299l-.183-.69.416.166-.852-2.085.413.09-1.206-1.5.332-.102-1.666-1.197.498-.132s-1.231-.624-2.636.132l.013-.261-.369.062.022-.287.367-.556-.55-.212s.444-.67.378-.66c0 0-.497.142-.468.083 0 0 .25-.645.184-.628 0 0-.576.196-.49.098l.22-.394L21.085 2z",
      fill: "#FBCD17"
    }
  ))
), s = t;
export {
  s as default
};
